import { UserInfo } from '../../../dto/user-info';

export class UserSelection {
  selected = new Array<UserInfo>();

  isSelected(item: UserInfo) {
    return this.selected.some((i) => i.id === item.id);
  }

  get count() {
    return this.selected.length;
  }

  hasValue() {
    return this.selected.length > 0;
  }

  clear() {
    this.selected = [];
  }

  select(item: UserInfo) {
    const localItem = this.selected.find((i) => i.id === item.id);
    if (!localItem) {
      this.selected.push(item);
    }
  }

  toggle(item: UserInfo) {
    const localItem = this.selected.find((i) => i.id === item.id);
    if (localItem) {
      this.selected = this.selected.filter((i) => i !== localItem);
    } else {
      this.selected.push(item);
    }
  }
}
